import { AlarmsService } from "app/data/services";

export const getAlarmTypes = async () => {
  const { data } = await AlarmsService.getAlarmTypes();
  return data;
};
